import request from "~/utils/http";

const userApi = {
	gets : async (params) => {
		const url = 'user';
		return await request.get(url, {params});
	},
	detail : async (id) => {
		const url = `user/${id}`;
		return await request.get(url);
	},
	status : async (params) => {
		const url = `user/status/${params.id}`;
		return await request.put(url, params);
	},
	add : async (params) => {
		const url = `user`;
		return await request.post(url, params);
	},
	update : async (params) => {
		const url = `user/${params.id}`;
		return await request.put(url, params);
	},
	role : async (params) => {
		const url = `user/role/${params.id}`;
		return await request.put(url, params);
	},
	password : async (params) => {
		const url = `user/password/${params.id}`;
		return await request.post(url, params);
	},
	getsLoginAs : async (params) => {
		const url = 'user/login-as';
		return await request.get(url, {params});
	},
};

export default userApi;